import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Loader } from "../../components/Loader";
import { CHOOSE_SUPERVISOR_TYPE, ONBOARDING } from "../../constants/routes";
import * as storageUtils from "../../utils/localStorage";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const InitializationPage = () => {
  let query = useQuery();

  const history = useHistory();

  useEffect(() => {
    let firstVisitFlag = storageUtils.getFirstVisitFlag();
    console.log({ firstVisitFlag });

    if (query.get("from")) {
      return;
    }

    if (!firstVisitFlag) {
      history.replace(ONBOARDING);
    } else {
      history.replace(CHOOSE_SUPERVISOR_TYPE);
    }
  }, [history, query]);

  return (
    <div className="centralized">
      <Loader />
    </div>
  );
};

export default InitializationPage;
